module.exports = __webpack_public_path__ + "static/media/ob-services.2861ea4a.svg";